import React from "react";
import { MessageCircle } from "lucide-react";

export default function MyHealthMessages({ unreadCount = 0, onOpen }) {
  const hasUnread = unreadCount > 0;

  return (
    <section className="p2-myhealth-msg">
      <p className="p2-myhealth-msg-title">Mesazhe me mjekët</p>

      <button type="button" onClick={onOpen} className="p2-myhealth-msg-btn">
        <div className="p2-myhealth-msg-icon">
          <MessageCircle className="p2-myhealth-msg-icon-svg" />
        </div>

        <div className="p2-myhealth-msg-main">
          <p className="p2-myhealth-msg-name">Bisedat e tua</p>
          <p className="p2-myhealth-msg-sub">
            {hasUnread
              ? `Ke ${unreadCount} mesazhe të palexuara.`
              : "Nuk ke mesazhe të reja. Mund të shkruash mjekut tënd kur të kesh nevojë."}
          </p>
        </div>

        {hasUnread && (
          <span className="p2-myhealth-msg-badge">{unreadCount}</span>
        )}
      </button>
    </section>
  );
}
